
import React, { useEffect, useState } from "react";
import bannerImg from "../assets/about-banner.webp";
import img1 from "../assets/about-image.webp";
import img2 from "../assets/two-more.jpeg";
import plantImg from "../assets/one.jpeg";
import img3 from "../assets/one.jpeg";
import img4 from "../assets/one-more.png";
import img5 from "../assets/quality.webp";

import "../App.css";
import { Helmet } from "react-helmet";                                   

const AboutUs = () => {

  /* ===== COUNTER DATA ===== */
  const counterData = [
    { value: 22, label: "Years of Manufacturing Experience" },
{ value: 4500, label: "Happy Clients Across India" },
{ value: 700, label: "Business Partners & Dealers" },
{ value: 500, label: "Innovative Kitchen & Wardrobe Products" },
  ];

  const [counts, setCounts] = useState(counterData.map(() => 0));

  useEffect(() => {
    const timer = setInterval(() => {
      setCounts((prev) =>
        prev.map((num, i) =>
          num < counterData[i].value ? num + 1 : num
        )
      );
    }, 30);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="about-wrapper">

      {/* ===== BANNER ===== */}
      <section className="about-hero">
        <img src={bannerImg} alt="About Banner" loading="lazy" />
        <div className="about-hero-overlay">
          <h1>ABOUT US</h1>
        </div>
      </section>

      {/* ===== CARDS ===== */}
      <section className="about-info-cards">
        <div className="about-container about-card-grid">
          <div className="about-info-card">
            <h3>Who We Are</h3>
            <p>
              We are a trusted hardware brand providing premium hinges, drawer
              channels, and furniture fittings designed for durability.
            </p>
          </div>

          <div className="about-info-card">
            <h3>Our Mission</h3>
            <p>
              To deliver reliable and innovative hardware solutions for modern
              interiors.
            </p>
          </div>

          <div className="about-info-card">
            <h3>Our Quality</h3>
            <p>
              High-grade materials ensuring smooth performance and long life.
            </p>
          </div>
        </div>
      </section>

      {/* ===== FLEX SECTION ===== */}
      <section className="about-flex-section">
        <div className="about-container about-flex-row">
          <div className="about-flex-image">
            <img src={img1} alt="Precision Hardware" loading="lazy" 
            />
          </div>
          <div className="about-flex-content">
            <h2>Precision & Performance</h2>
            <p>
             Precision and performance are the core strengths of our company. We focus on delivering high-quality kitchen and furniture hardware that ensures smooth operation, durability, and long-lasting reliability. Every product is carefully designed using advanced technology and strict quality standards to provide accurate fitting and flawless functionality. Our hardware solutions are built to handle daily use while maintaining consistent performance over time. From hinges to drawer systems and pull-out accessories, each item reflects our commitment to strength, efficiency, and modern design. By combining precision engineering with dependable performance, we provide products that enhance convenience, improve functionality, and add lasting value to every kitchen and furniture space.
            </p>
          </div>
        </div>
      </section>

      {/* ===== COUNTER SECTION (NEW) ===== */}
      <section className="about-counter-section">
        <div className="about-container">
          <h2 className="about-counter-title"> Slimline At a Glance</h2>

          <div className="about-counter-grid">
            {counterData.map((item, index) => (
              <div className="about-counter-box" key={index}>
                <h3>{counts[index]}+</h3>
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== MORE PICTURES ===== */}
      <section className="about-gallery-section">
        <div className="about-container">
          <h2 className="about-gallery-title">MORE PICTURES</h2>

          <div className="about-gallery-grid">
            <div className="gallery-item large">
              <img src={img3} alt="Plant Facility" loading="lazy" />
            </div>

            <div className="gallery-item">
              <img src={img4} alt="Soil Compost" loading="lazy" />
            </div>

            <div className="gallery-item">
              <img src={img2} alt="Garden Flowers" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== RAINWATER ===== */}
      <section className="about-rainwater">
        <div className="about-container about-rainwater-row">
          <div className="about-rainwater-text">
            <h2>Quality & Innovation in Hardware</h2>
            <p>
              At Slimline, we are committed to delivering high-quality kitchen and furniture hardware designed for durability, efficiency, and modern living. Our products are developed with advanced technology and innovative design to ensure smooth performance and long-lasting reliability. From hinges and drawer slides to pull-out systems and storage solutions, every product is crafted with precision and strict quality standards. We continuously focus on innovation to improve functionality, strength, and user convenience. By combining quality materials with smart engineering, Slimline provides hardware solutions that enhance both the performance and aesthetics of modern kitchens and furniture spaces.
            </p>
          </div>
          <div className="about-rainwater-image">
            <img src={img5} alt="Rainwater System" loading="lazy" />
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;
